import { createAsyncThunk } from "@reduxjs/toolkit";
import { DashboardStatServices } from "@root/services/stats";
import { getBaseUrl } from "@root/store/selectors/features";
import {
  CHATBOT_CHATS,
  DASHBOARD_GET_CHATS,
  DASHBOARD_GET_REPORTS,
  DASHBOARD_GET_STATS,
} from "@root/store/action-types/dashboard";

const dashboardService = new DashboardStatServices();

export const getDashboardStats: any = createAsyncThunk(
  DASHBOARD_GET_STATS,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError } = requestPayload || {};
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await dashboardService.getStatsData({
        baseUrl,
        onSuccess,
        onError,
      });
      return thunkAPI.fulfillWithValue(result);
    } catch (error) {
      if (onError) onError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getDashboardReports: any = createAsyncThunk(
  DASHBOARD_GET_REPORTS,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, data } = requestPayload || {};
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await dashboardService.getReports({
        baseUrl,
        data,
        onSuccess,
        onError,
      });
      return thunkAPI.fulfillWithValue(result);
    } catch (error) {
      if (onError) onError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getDashboardChats: any = createAsyncThunk(
  DASHBOARD_GET_CHATS,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, data } = requestPayload || {};
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await dashboardService.getChats({
        baseUrl,
        data,
        onSuccess,
        onError,
      });
      return thunkAPI.fulfillWithValue(result);
    } catch (error) {
      if (onError) onError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getChatbotChats: any = createAsyncThunk(
  CHATBOT_CHATS ,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, data } = requestPayload || {};
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await dashboardService.getLastChatsByType({
        baseUrl,
        data,
        onSuccess,
        onError,
      });
      return thunkAPI.fulfillWithValue(result);
    } catch (error) {
      if (onError) onError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
  
);